import { render, staticRenderFns } from "./NewChargebackType.vue?vue&type=template&id=4a10f051&"
import script from "./NewChargebackType.vue?vue&type=script&lang=js&"
export * from "./NewChargebackType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports